import {
    BarChartOutlined,
    UserOutlined,
} from '@ant-design/icons';
import ConsignmentsIcon from 'assets/consignments';
import TruckIcon from 'assets/truck-icon';

interface MenuItemSelectedBase {
    key: string;
}

interface MenuItemWithSubmenu extends MenuItemSelectedBase {
    isSubmenu: true;
    submenuKey: string;
}

interface MenuItemWithoutSubmenu extends MenuItemSelectedBase {
    isSubmenu?: false;
}

export type MenuItemSelected = MenuItemWithSubmenu | MenuItemWithoutSubmenu;

// creating enum for submenu keys
export enum SubmenuItems {
    SHIPMENT = 'shipments',
    FINANCES = 'finances',
    SETTINGS = 'settings',
    INFORMATION = 'information centre',
    INVOICES = 'invoices',
}

export const mobileMenuItems = [
    {
        key: 'analytics',
        name: 'Dashboard',
        route: '/analytics',
        icon: BarChartOutlined,
    },
    {
        key: 'consignments',
        name: 'Consignments',
        route: '/consignments',
        icon: ConsignmentsIcon,
    },
    {
        key: 'pickups',
        name: 'Pickups',
        route: '/pickups',
        icon: TruckIcon,
    },
    {
        key: 'settings/account',
        name: 'Profile',
        route: '/settings/account',
        icon: UserOutlined,
    },
];
